import { render } from "./AksNodePool.vue?vue&type=template&id=0a1fef00&scoped=true&ts=true"
import script from "./AksNodePool.vue?vue&type=script&lang=ts"
export * from "./AksNodePool.vue?vue&type=script&lang=ts"

import "./AksNodePool.vue?vue&type=style&index=0&id=0a1fef00&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1fef00"]])

export default __exports__